import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import Modal from "../../../components/Modal/Modal";
import useAuth from "../../../hooks/useAuth";
import { BASE_URL } from "../../../utils/Element";
import { ROUTES } from "../../../routes/routeKeys";
import SearchResults from "./SearchResults";

const GlobalSearchModal = ({ showModal, onClose }) => {
  const [config] = useAuth();
  const navigate = useNavigate();
  const [query, setQuery] = useState("");
  const [results, setResults] = useState(null);
  const [loading, setLoading] = useState(false);
  const [selectedFilter, setSelectedFilter] = useState("all");
  
  const inputRef = useRef(null);

  useEffect(() => {
    if (showModal) {
      setTimeout(() => {
        if (inputRef.current) inputRef.current.focus();
      }, 100);
    } else {
      setQuery("");
      setResults(null);
      setSelectedFilter("all");
    }
  }, [showModal]);

  useEffect(() => {
    if (!query.trim()) {
      setResults(null);
      return;
    }

    const timer = setTimeout(() => {
      fetchResults(query, selectedFilter);
    }, 500);

    return () => clearTimeout(timer);
  }, [query, selectedFilter]);

  const fetchResults = (searchQuery, filterType) => {
    setLoading(true);
    const typeParam = filterType === "all" ? "" : `&type=${filterType}`;
    axios
      .get(`${BASE_URL}/global-search?query=${encodeURIComponent(searchQuery)}${typeParam}&limit=10`, config)
      .then((res) => {
        setResults(res.data?.data);
      })
      .catch((err) => {
        console.error("Global search error:", err);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleNavigate = (type, id) => {
    onClose();
    if (type === "property") {
      navigate(ROUTES.PROPERTY_DETAILS.replace(":id", id));
    } else if (type === "contact") {
      navigate(ROUTES.CONTACT_DETAILS.replace(":id", id));
    } else if (type === "company") {
      navigate(ROUTES.COMPANY_DETAILS.replace(":id", id));
    }
  };

  return (
    <Modal width="700px" title="Global Search" show={showModal} onClose={onClose} disableContentWrapperStyle={true} closeOnOutsideClick={true}>
      <div className="flex flex-col">
        <div className="pr-5 pt-3 pb-2">
          <input
            ref={inputRef}
            type="text"
            className="w-full border border-gray-300 rounded-lg px-4 py-3 body-L dark-H outline-none focus:border-[#2D5B30] shadow-sm"
            placeholder="Search for properties, contacts, or companies... (Ctrl+F)"
            value={query}
            onChange={(e) => setQuery(e.target.value)}
          />
        </div>

        <div className="pr-5">
          <SearchResults 
            results={results}
            query={query}
            loading={loading}
            handleNavigate={handleNavigate}
            selectedFilter={selectedFilter}
            setSelectedFilter={setSelectedFilter}
            containerHeight="max-h-[500px]"
          />
        </div>
      </div>
    </Modal>
  );
};

export default GlobalSearchModal;
